import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalModule, TooltipModule } from 'ngx-bootstrap';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { AiActivitiesComponent } from './ai-activities.component';

@NgModule({
  declarations: [AiActivitiesComponent],
  imports: [
    CommonModule,
    FormsModule,
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    PipesModule
  ],
  entryComponents: [AiActivitiesComponent],
  exports: [AiActivitiesComponent]
})
export class AiActivitiesModule { }
